import qr from '../../images/qr.jpeg';
import logo from '../../images/favicon-removebg.png';

const QRPage = () => {
    return (
        <>
            <div className='mx-auto my-8 flex w-full max-w-6xl flex-col items-center justify-evenly gap-6 px-4 sm:my-10 md:flex-row md:gap-10'>
                <div className='mt-2 md:mt-0'>
                    <h2 className='mb-4 text-center text-2xl font-bold sm:text-3xl md:text-4xl'>You are paying to </h2>
                    <img
                        src={logo}
                        alt='Decodiefy Technologies'
                        className='mx-auto h-auto w-full max-w-[280px] object-cover sm:max-w-[340px] md:mx-0 md:max-w-[380px]'
                    />
                </div>

                <div className='h-fit w-full max-w-[320px] p-4 pb-4 border-2 bg-white border-gray-300 hover:bg-green-100 rounded-xl shadow-lg transition-transform transform md:hover:scale-105 md:mr-8 sm:max-w-[360px] md:max-w-[390px]'>
                    <img
                        src={qr}
                        alt='QR Code'
                        className='w-full h-auto rounded-lg object-cover'
                    />
                    <p className='text-center mt-2 text-green-600 text-lg sm:text-xl font-bold'>Scan Here</p>
                </div>
            </div>
            {/* <p className='w-full p-3 text-center text-base font-bold text-red-500 bg-green-100 shadow sm:text-lg'>
                Note: For more information, contact +91 9876543210
            </p> */}
        </>
    );
};

export default QRPage;
